import DetailPageLayout from "../Layout/DetailPageLayout";
import {
  ContentContainer,
  RegisterHeader,
  RegisterPhoneInput,
  RegisterWrapper,
  PhoneButtonText,
  PhoneButton,
} from "./RegisterPhone.styles";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { registerAtom } from "../../recoil/atoms";
import { useSetRecoilState } from "recoil";
import { useReloadWarning } from "../../common/hooks";
import { TextM, TextS } from "../../common/text";

const RegisterPhone = () => {
  const navigate = useNavigate();
  const setRegisterAtom = useSetRecoilState(registerAtom);
  const [phoneNum, setPhoneNum] = useState("");
  const [phoneNumMessage, setPhoneNumMessage] = useState("");
  const [isValidPhoneNum, setIsValidPhoneNum] = useState(false);

  const phoneNumRegex = /^(\d{3})-(\d{4})-(\d{4})$/;

  const onCheckPhoneNum = (e) => {
    const currentPhoneNum = e.target.value
      .replace(/[^0-9]/g, "")
      .replace(/^(\d{2,3})(\d{3,4})(\d{4})$/, `$1-$2-$3`);
    setPhoneNum(currentPhoneNum);

    if (!phoneNumRegex.test(currentPhoneNum)) {
      setIsValidPhoneNum(false);
      setPhoneNumMessage("전화번호를 확인해주세요");
    } else {
      setIsValidPhoneNum(true);
      setPhoneNumMessage("인증버튼을 눌러주세요");
      setRegisterAtom((prev) => ({
        ...prev,
        phone: currentPhoneNum.replaceAll("-", ""),
      }));
    }
  };

  useReloadWarning();

  const goNext = () => {
    if (isValidPhoneNum) navigate("/register/phone/validate");
  };
  return (
    <DetailPageLayout headerText={"휴대폰인증"}>
      <ContentContainer>
        <RegisterHeader>
          <TextM>휴대폰 본인 인증이 필요합니다.</TextM>
          <TextM>휴대전화번호를 입력해주세요</TextM>
        </RegisterHeader>
        <RegisterWrapper>
          <RegisterPhoneInput
            onChange={onCheckPhoneNum}
            value={phoneNum}
            placeholder={"숫자만 입력해주세요."}
            variant="standard"
            helperText={
              phoneNum && <TextS color={"#f44b59"}>{phoneNumMessage}</TextS>
            }
          ></RegisterPhoneInput>
        </RegisterWrapper>

        <PhoneButton onClick={goNext} isValidPhoneNum={isValidPhoneNum}>
          <PhoneButtonText isValidPhoneNum={isValidPhoneNum}>
            휴대폰인증
          </PhoneButtonText>
        </PhoneButton>
      </ContentContainer>
    </DetailPageLayout>
  );
};

export default RegisterPhone;
